import { useEffect, useState, useContext } from 'react';
import { useAPI } from '../services/api';
import ToastContext from '../contexts/toast-context';
import NewsFeed from 'src/components/post';
import LoadingOverlay from 'src/components/page/LoadingOverlay';
import AddPostDropdown from 'src/components/post/AddPostDropdown';
import PostFormModal from 'src/components/modal/PostForm';
import DeletePostModal from 'src/components/modal/DeletePost';
import Sidebar from 'src/components/sidebar';

const HomePage = () => {
  const [showPostFormModal, setShowPostFormModal] = useState(false);
  const [showDeletePostModal, setShowDeletePostModal] = useState(false);
  const [editing, setEditing] = useState(false);
  const [postID, setPostID] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  const { handleError, success } = useContext(ToastContext);

  const api = useAPI();

  useEffect(() => {
    const getPosts = async () => {
      try {
        setLoading(true);
        let { data } = await api.get(`/posts`);
        setPosts(data);
      } catch (e) {
        handleError(e);
      }
      setLoading(false);
    };
    getPosts();
  }, [api, handleError]);

  const handleDeleteClick = (postID) => {
    setPostID(postID);
    setShowDeletePostModal(true);
  };

  const handleEditClick = (postID) => {
    setPostID(postID);
    setEditing(true);
    setShowPostFormModal(true);
  };

  const handleDeletePost = async () => {
    try {
      setLoading(true);
      await api.delete(`/posts/${postID}`);
      setPostID(null);
      setPosts(posts.filter((post) => post.id !== postID));
      success('Deleted post!');
    } catch (e) {
      handleError(e);
    }
    setLoading(false);
    setShowDeletePostModal(false);
  };

  return (
    <LoadingOverlay isLoading={loading}>
      <div className="container mx-auto">
        <AddPostDropdown openModal={setShowPostFormModal} />
        <div className="flex flex-col pb-20 mt-8 lg:flex-row">
          <div className="w-full lg:w-2/3">
            <div className="text-lime-600 font-bold mb-6 text-lg">EMERGENCY NEWS FEED</div>
            <NewsFeed
              posts={posts}
              onDeleteClick={(postID) => handleDeleteClick(postID)}
              onEditClick={(postID) => handleEditClick(postID)}
            />
          </div>
          <div className="w-full mt-16 lg:w-1/3 lg:pl-28 lg:mt-0 ">
            <Sidebar />
          </div>
        </div>
      </div>
      <DeletePostModal
        show={showDeletePostModal}
        onHide={() => {
          setShowDeletePostModal(false);
          setPostID(null);
        }}
        onDelete={handleDeletePost}
      />
      <PostFormModal
        show={showPostFormModal}
        onHide={() => {
          setShowPostFormModal(false);
          if (editing) setEditing(false);
          setPostID(null);
        }}
        setPosts={setPosts}
        isEditing={editing}
        postToEdit={posts.find((post) => post.id === postID)}
      />
    </LoadingOverlay>
  );
};

export default HomePage;
